// This file is updated using the cli
// No not modify!
import React from 'react';
const Icon = (props) => {
    return (React.createElement("svg", Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 54 54", width: "54", height: "54" }, props),
        React.createElement("path", { d: "M6.75 11C3.0285 11 0 14.2763 0 18V31.5C0 35.2215 3.0285 38 6.75 38H13L18.3217 51.1717C19.026 52.9312 20.7158 54 22.5023 54C23.058 54 23.6227 53.8965 24.1717 53.676C26.478 52.7535 27.6008 50.1345 26.6783 47.826L22.5 38H30.5L45 49.5V0L31 11H6.75ZM49 16V33C51.6775 31.4453 54 27.8142 54 24.5C54 21.1858 51.6775 17.5525 49 16Z" })));
};
Icon.displayName = 'Megaphone54x54';
export default Icon;
//# sourceMappingURL=Megaphone54x54.js.map